import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import AdvertiseModal from "../../components/Advertise/AdvertiseModal";
import UseMobile from "../../hooks/useIsMobile";
import { useMediaQuery, useTheme } from "@material-ui/core";

import MobileAdverise from "./MobileAdvertise";
import { useDispatch, useSelector } from "react-redux";
import { toggleAdvertisement } from "../../redux/action/utilActions";

const useStyles = makeStyles((theme) => ({
  root: {},
}));

const Advetise = ({ data }) => {
  const classes = useStyles();
  const theme = useTheme();
  const dispatch = useDispatch();

  const open = useSelector((state) => state.util.advertiseModalOpen);

  const isMobile = useMediaQuery(theme.breakpoints.only("xs"));

  return (
    <div className={classes.root}>
      {data && (
        <div>
          {!isMobile ? (
            <div>
              {open && (
                <AdvertiseModal
                  open={open}
                  data={data}
                  onClose={() => dispatch(toggleAdvertisement())}
                />
              )}
            </div>
          ) : (
            <div>
              <MobileAdverise data={data} />
            </div>
          )}
        </div>
      )}
    </div>
  );
};
export default Advetise;

// import React from "react";
// import { makeStyles } from "@material-ui/core/styles";
// import {
//   Box,
//   Container,
//   Divider,
//   Grid,
//   Hidden,
//   Typography,
// } from "@material-ui/core";
// import fontConfig from "../../constants/fonts";
// import {
//   CarouselProvider,
//   Slider,
//   Slide,
//   ButtonBack,
//   ButtonNext,
// } from "pure-react-carousel";

// import AchievementItem from "./AchievemntItem";
// import CarouselBtn from "../../components/Common/Buttons/CarouselBtn";
// import TitleContainer from "./TitleContainer";
// import UseMobile from "../../hooks/useIsMobile";
// import LayoutContainer from "../../components/LayoutsContainer";
// const useStyles = makeStyles((theme) => ({
//   root: {
//     paddingTop: theme.spacing(5),
//     paddingBottom: theme.spacing(2),
//     // backgroundColor: theme.palette.primary.lightGray,
//     [theme.breakpoints.down("md")]: {
//       // height: "100%",
//       paddingTop: theme.spacing(2),
//       // paddingBottom: theme.spacing(0),
//     },
//   },
//   Divider: {
//     marginBottom: theme.spacing(5),
//     [theme.breakpoints.down("md")]: {},
//   },
//   titleContainer: {
//     [theme.breakpoints.down("md")]: {
//       // backgroundColor: "yellow",
//     },
//   },
//   title: {
//     ...fontConfig.bold,
//     fontSize: "2rem",
//     color: "white",
//     backgroundColor: theme.palette.primary.main,
//     // awidth: "20%",
//     // width: "15%",
//     textAlign: "center",
//     padding: 10,
//     // padding: "10 30px",
//     // wordWrap: "no-wrap",
//   },
//   personalityContainer: {
//     marginTop: theme.spacing(3),
//     display: "flex",
//     flexDirection: "row",
//     justifyContent: "space-between",
//     alignItems: "center",
//   },
//   CarouselProvider: {
//     marginTop: theme.spacing(5),
//     [theme.breakpoints.down("md")]: {
//       marginTop: theme.spacing(2),
//       // backgroundColor: "red",
//     },
//   },
//   btns: {
//     backgroundColor: "transparent",
//     border: "none",
//   },
//   gridContainer: {
//     // backgroundColor: "red",
//     width: "100%",
//     backgroundColor: theme.palette.lightGray,
//   },
//   adImg: {
//     width: "50%",
//     objectFit: "contain",
//   },
// }));

// const Advertisement = ({ data }) => {
//   const classes = useStyles();
//   const isMobile = UseMobile();
//   console.log("data", data);
//   return (
//     <>
//       <div className={classes.root}>

//         {/* <Grid container>
//           <Grid item lg={10} md={10} xs={12} sm={12}>
//             {data.title && (
//               <>
//                 <Hidden mdDown>
//                   <Grid container className={classes.gridContainer}>
//                     <Grid item className={classes.titleContainer}>
//                       <TitleContainer title={data.title} />
//                     </Grid>
//                   </Grid>
//                 </Hidden>
//                 <Hidden smUp>
//                   <Grid
//                     container
//                     justify="center"
//                     className={classes.gridContainer}
//                   >
//                     <Grid item className={classes.titleContainer}>
//                       <TitleContainer title={data.title} />
//                     </Grid>
//                   </Grid>
//                 </Hidden>
//               </>
//             )}
//           </Grid>
//         </Grid>

//         <div className={classes.CarouselProvider}>
//           <img
//             src="https://source.unspash.com/random"
//             className={classes.adImg}
//           />
//         </div> */}
//       </div>
//     </>
//   );
// };
// export default Advertisement;
